// Disable Zone on keypress and keyup events for better typing performance
(<any>window).__zone_symbol__UNPATCHED_EVENTS = ['keyup', 'keypress'];
